// extracted by mini-css-extract-plugin
module.exports = {"flavorSelector":"ConsumablesFlavorSelectorSection_flavorSelector__TXpxA"};